module.exports = __webpack_public_path__ + "static/LifeTimeAwardImg-6fb643318076fc1805c866b73fbeb2b2.png";